import script from "./SupViewAllGroupTalks.vue?vue&type=script&setup=true&lang=js"
export * from "./SupViewAllGroupTalks.vue?vue&type=script&setup=true&lang=js"

import "./SupViewAllGroupTalks.vue?vue&type=style&index=0&id=390a1c64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-390a1c64"]])

export default __exports__